import { render, staticRenderFns } from "./ProductNotPrintableNotification.vue?vue&type=template&id=877bf2ee"
import script from "./ProductNotPrintableNotification.vue?vue&type=script&lang=ts"
export * from "./ProductNotPrintableNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports